enum OperatingLeaseProductsEntrepreneurEnum {
    OLFOP24 = "OLFOP24",
    OLFOP36 = "OLFOP36",
}

export default OperatingLeaseProductsEntrepreneurEnum;
